export function s_possesive(text) {
    return `


<div class=WordSection1>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
.75pt'>Possessive pronouns - Easy Learning Grammar Spanish</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>What is a possessive pronoun?</span></b><span style='font-size:
12.0pt;font-family:"inherit",serif;color:black'><br>
</span><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>A&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>possessive pronoun</span></b><span style='font-size:12.0pt;
font-family:"Open Sans",sans-serif;color:black'>&nbsp;is one of the words&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>mine, yours,
hers, his, ours</span></i><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>&nbsp;or&nbsp;</span><i><span style='font-size:12.0pt;font-family:
"inherit",serif;color:black'>theirs,</span></i><span style='font-size:12.0pt;
font-family:"Open Sans",sans-serif;color:black'>&nbsp;which are used instead of
a noun to show that one person or thing belongs to another, for example,&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>Ask Carole if
this pen is</span></i><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>&nbsp;</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>hers.;</span></i><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>&nbsp;</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Mine’s</span></i><span style='font-size:12.0pt;font-family:"Open Sans",sans-serif;
color:black'>&nbsp;</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>the blue one.</span></i></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal'><span
style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Here are the Spanish possessive pronouns:</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Masculine singular</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Feminine singular</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Masculine plural</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Feminine plural</span></b></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Meaning</span></b></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el mío</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la mía</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los míos</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las mías</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>mine</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el tuyo</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la tuya</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los tuyos</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las tuyas</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>yours
  (<i>belonging to</i>&nbsp;<b>tú</b>)</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el suyo</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la suya</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los suyos</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las suyas</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>his;
  hers; its; yours (<i>belonging to</i>&nbsp;<b>usted</b>)</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el nuestro</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la nuestra</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los nuestros</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las nuestras</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>ours</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el vuestro</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la vuestra</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los vuestros</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las vuestras</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>yours
  (<i>belonging to</i>&nbsp;<b>vosotros</b>/<b>vosotras</b>)</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>el suyo</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>la suya</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>los suyos</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>las suyas</span></b></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>theirs;
  yours (<i>belonging to</i>&nbsp;<b>ustedes</b>)</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal'><span
style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>For more information on</span></i><span style='font-size:12.0pt;
font-family:"inherit",serif;color:black'>&nbsp;<b><i>Ways of saying ‘you’ in
Spanish</i></b><i>, see&nbsp;<a
href="https://grammar.collinsdictionary.com/spanish-easy-learning/pronouns"
title="Explanation of Pronouns"><span style='color:blue'>Pronouns</span></a>.</i></span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Pregunta a Cristina si este bolígrafo es</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>el
  suyo.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>Ask
  Cristina if this pen is hers.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>&iquest;Qué equipo ha ganado,</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>el
  suyo</b>&nbsp;<b>o</b>&nbsp;<b>el nuestro?</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>Which
  team won – theirs or ours?</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Mi perro es más joven que</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>el
  tuyo.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>My
  dog is younger than yours.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Daniel pensó que esos libros eran</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>los
  suyos.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>Daniel
  thought those books were his.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Si no tienes lápices, te prestaré</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>los
  míos.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>If
  you haven’t got any pencils, I’ll lend you mine.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Las habitaciones son más peque&ntilde;as que</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>las
  vuestras.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>The
  rooms are smaller than yours.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal'><span style='font-size:13.5pt;font-family:"inherit",serif;color:black'>TipIn
Spanish, possessive pronouns agree with what they describe,&nbsp;NOT&nbsp;with
the person who owns that thing. For example,&nbsp;<b>el suyo</b>&nbsp;can
mean&nbsp;<i>his</i>,&nbsp;<i>hers</i>,&nbsp;<i>yours</i>&nbsp;or&nbsp;<i>theirs</i>,
but can only be used to replace a masculine singular noun.</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal'><span
style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Note that the prepositions&nbsp;<b>a</b>&nbsp;and&nbsp;<b>de</b>&nbsp;combine
with the article&nbsp;<b>el</b>&nbsp;to form&nbsp;<b>al</b>&nbsp;and&nbsp;<b>del</b>,
for example,&nbsp;<b>a + el mío</b>&nbsp;becomes&nbsp;<b>al mío</b>, and&nbsp;<b>de
+ el mío</b>&nbsp;becomes&nbsp;<b>del mío</b>.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Prefiero tu coche</span></b><span lang=ES-MX style='font-size:
  12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>al mío.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>I
  prefer your car to mine.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Su coche se parece</span></b><span lang=ES-MX style='font-size:
  12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>al vuestro.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>His/Her/Their
  car looks like yours.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Mi piso está encima</span></b><span lang=ES-MX style='font-size:
  12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>del tuyo.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>My
  flat is above yours.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Su colegio está cerca</span></b><span lang=ES-MX
  style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>del
  nuestro.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>His/Her/Your/Their
  school is near ours.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal'><span
style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>Instead of&nbsp;<b>el suyo</b>/<b>la suya</b>/<b>los suyos</b>/<b>las
suyas</b>, it is sometimes clearer to say&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las
de usted</b>,&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las de ustedes</b>,&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las
de ellos</b>&nbsp;and so on. </span><span style='font-size:12.0pt;font-family:
"inherit",serif;color:black'>You choose between&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las</b>&nbsp;to
agree with the noun referred to.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>mi libro y</span></b><span lang=ES-MX style='font-size:12.0pt;
  font-family:"inherit",serif;color:black'>&nbsp;<b>el de</b>&nbsp;<b>usted</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>my
  book and yours</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal'><span
style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>el</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>/<b>la</b>/<b>los</b>/<b>las de</b>&nbsp;can also be used with a
name or other noun referring to somebody.</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Juan tiene un coche bonito pero yo prefiero</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>el
  de</b>&nbsp;<b>Ana.</b></span></p>
  </td>
  <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>Juan’s
  got a nice car, but I prefer Ana’s.</span></p>
  </td>
 </tr>
 <tr>
  <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
  color:black'>Ellos tienen una casa bonita pero yo prefiero</span></b><span
  lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b>la
  del</b>&nbsp;<b>médico.</b></span></p>
  </td>
  <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
  border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
  normal'><span style='font-size:12.0pt;font-family:"inherit",serif;color:black'>They’ve
  got a nice house but I prefer the doctor’s.</span></p>
  </td>
 </tr>
</table>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
color:black'>Key points</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>The Spanish possessive pronouns are&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el mío</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el tuyo</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el suyo</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el nuestro</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el vuestro</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;and&nbsp;</span><b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>el suyo</span></b><span
style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;when
they stand in for a masculine noun. If they stand in for a feminine or a plural
noun, their forms change accordingly.</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>In Spanish, the pronoun you choose has to agree with the noun it
replaces, and&nbsp;</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>not</span><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;with the person who owns that thing.</span></p>

<p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
normal;background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>el</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>/</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>la</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>/</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>los</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>/</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:black'>las de</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
color:#B71533'>&nbsp;are used with a noun or pronoun to mean the&nbsp;</span><i><span
style='font-size:12.0pt;font-family:"inherit",serif;color:black'>one(s)
belonging to .</span></i></p>

<p class=MsoNormal>&nbsp;</p>
`;
}
